import React from "react";
import { RequestStatusCards } from "../../RequestStatusCards";

// All / Pending / Approved / Rejected / Cancelled tallies for the active
// attendance type. Clicking a tile filters the history table to that status
// (activeStatus); "All" (empty filter value) shows the grand total and
// clears any active filter. Rendered through the shared RequestStatusCards
// so it matches Team Workspace > Approvals' status cards.
export const AttendanceStatusTiles = ({ counts, activeStatus, onSelect }) => (
  <RequestStatusCards counts={counts} activeStatus={activeStatus} onSelect={onSelect} />
);
